export default "__VITE_ASSET__DiqgNW5$__"